export function processItem(array, item) {
    item.ID && Number(item.ID) !== NaN && (array[Number(item.ID)] = item);
}
//# sourceMappingURL=processItem.js.map